import { Divider, Grid, IconButton, Tooltip,useTheme } from "@mui/material";
import React, { useState } from "react";
import { tokens } from "../../theme/theme";

import DoneAllIcon from '@mui/icons-material/DoneAll';
import LooksOutlinedIcon from '@mui/icons-material/LooksOutlined';
import CommitOutlinedIcon from '@mui/icons-material/CommitOutlined';
import BedroomChildIcon from '@mui/icons-material/BedroomChild';
import KitchenOutlinedIcon from '@mui/icons-material/KitchenOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

import ArrowBack from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import TableViewIcon from '@mui/icons-material/TableView';
import MachineIcon from "@mui/icons-material/PrecisionManufacturingOutlined";
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import StandardSize from "@mui/icons-material/FireTruckOutlined";
import Execute from "@mui/icons-material/PlayArrowOutlined";
import Report from "@mui/icons-material/AssessmentOutlined";
import Release from "@mui/icons-material/MoveUp";
import FactoryOutlinedIcon from '@mui/icons-material/FactoryOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { useTranslation } from "react-i18next";


const MasterAdminActionMenu = ({ SetActive}) => {

    const [selectedButton, setSelectedButton] = useState(null);

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);       
    };
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();   

    return (
        
        <Grid container display="flex-start" padding={1}>          

            {/* Add Button */}
            <Grid item md={0} ml="5px" mr="5px">
                <Tooltip title="Add orders">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('AddOrders')}  >
                            <FactoryOutlinedIcon style={{ color: selectedButton === 'AddOrders' ? "yellow" : "#009688"  }} />
                        </IconButton>
                        <span style={{ fontSize: 12 }}>Company Management</span>
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem  sx={{marginLeft:"10px",marginRight:"10px"}}/>
            {/* Add Button */}
            <Grid item md={0} ml="5px" mr="5px">
                <Tooltip title="Add input orders">
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <IconButton onClick={() => handleButtonClick('InputOrders')}>
                        <AccountCircleOutlinedIcon style={{ color: selectedButton === 'InputOrders' ? "yellow" : "#009688"  }} />
                    </IconButton>
                    <span style={{  fontSize: 12 }}>User Management</span>
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem  sx={{marginLeft:"10px",marginRight:"10px"}}/>
            {/* Add Button */}
            {/* <Grid item md={0} ml="5px" mr="5px">
            
                <Tooltip title="View machine parameters">
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <IconButton onClick={() => handleButtonClick('Machines')}>
                        <MachineIcon style={{ color: selectedButton === 'Machines' ? "yellow" : "#009688"  }} />
                    </IconButton>
                    <span style={{  fontSize: 12 }}>Machines</span>
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem  sx={{marginLeft:"10px",marginRight:"10px"}}/> */}
            {/* Add Button */}
            {/* <Grid item md={0} ml="5px" mr="5px">
                <Tooltip title="Parameter Settings">
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <IconButton onClick={() => handleButtonClick('Parameters')}>
                        <TuneOutlinedIcon style={{ color: selectedButton === 'Parameters' ? "yellow" : "#009688" }} />
                    </IconButton>
                    <span style={{  fontSize: 12 }}>Parameters</span>
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem  sx={{marginLeft:"10px",marginRight:"10px"}}/> */}
            {/* Add Button */}
            {/* <Grid item md={0} ml="5px" mr="5px">
                <Tooltip title="Add Standard Sizes">
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <IconButton onClick={() => handleButtonClick('AddStandardSize')}>
                        <StandardSize style={{color: selectedButton === 'AddStandardSize' ? "yellow" : "#009688" }} />
                    </IconButton>
                    <span style={{  fontSize: 12 }}>Add Standard Sizes</span>
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem  sx={{marginLeft:"10px",marginRight:"10px"}}/> */}
            {/* Add Button */}
            {/* <Grid item md={0} ml="5px" mr="5px">
                <Tooltip title="Execute to Match Order">
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <IconButton onClick={() => handleButtonClick('Run')}>
                        <Execute style={{ color: selectedButton === 'Run' ? "yellow" : "#009688" }} />
                    </IconButton>
                    <span style={{  fontSize: 12 }}>Run</span>
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem  sx={{marginLeft:"10px",marginRight:"10px"}}/> */}
             {/* Add Button */}
             {/* <Grid item md={0} ml="5px" mr="5px">
                <Tooltip title="View All Reports">
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <IconButton onClick={() => handleButtonClick('Reports')}>
                        <Report style={{ color: selectedButton === 'Reports' ? "yellow" : "#009688" }} />
                    </IconButton>
                    <span style={{  fontSize: 12 }}>Reports</span>
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem  sx={{marginLeft:"10px",marginRight:"10px"}}/> */}
             {/* Add Button */}
             {/* <Grid item md={0} ml="5px" mr="5px">
                <Tooltip title="Release Manufacturing Order">
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <IconButton onClick={() => handleButtonClick('Release')}>
                        <Release style={{ color: selectedButton === 'Release' ? "yellow" : "#009688" }} />
                    </IconButton>
                    <span style={{  fontSize: 12 }}>Release MO</span>
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem  sx={{marginLeft:"10px",marginRight:"10px"}}/> */}
        </Grid>



    )
};
export default MasterAdminActionMenu;